import { mapFilterConstant, mapConstants } from "../../store/actionTypes";

// const initState = (user && token) ? { loggedIn: true, user, token } : {};
const initState = {
  todayIncident: false,
  clearFilters: false,
  // filter and sidebar handling variables
  showFilters: true, // sidebar filter screen handler
  sidebarOpen: false, // sidebar open close handler
  // Loading variables
  mapLoading: false, //This variabe will show map Loader
  dataLoading: true, // This shows data is being loaded from filters API and is used to display loader on filter sidebar
  // This variable will check LatLng of marker to be zoomed
  zoomObject: [], // This will save latitude and logitude of click element in navbar and panTo over it with animation

  nextPage: null, // This will specify next page is existed or not? (responsible to display next page icon)
  recordCount: 0, // current record count in view incident data window
  totalRecordCount: null, // total record count in view incident data window

  filter: false, //This variable is responsible to figure out either the data loaded iss of showAll true request or filtered Data request

  filterData: [], // Recieve filtered data from API for filters and on map load
  filterDataError: null,
  heatMapData: [], // recieve heatMap record
  heatMapDataError: null,
  filterMetaData: [], // will recieve sidebar attribute options
  filterMetaError: null,
  getAreasData: [],
  getAreasError: null,
  showMyPolygonList: false,
  getMyGeofenceDataResult: [],
  getMyGeofenceDataLoading: true,
};

const mapReducer = (state = initState, action) => {
  switch (action.type) {
    case mapFilterConstant.CLEAR_FILTER_STATES:
      return {
        ...state,
        clearFilters: action.state,
      };

    //MY GEOFENCE DATA
    case mapFilterConstant.MY_GEOFENCE_DATA_REQ:
      // return state;
      return {
        ...state,
        getMyGeofenceDataLoading: true,
      };
    case mapFilterConstant.MY_GEOFENCE_DATA_SUCCESS:
      // console.log("my-geofence-data", action.resp.data);
      return {
        ...state,
        getMyGeofenceDataResult: action.resp.data.data,
        getMyGeofenceDataLoading: false,
      };
    case mapFilterConstant.MY_GEOFENCE_DATA_FAILURE:
      return {
        ...state,
        // filterMetaError: action.error,
      };

    //MAP FILTER META DATA
    case mapFilterConstant.FILTER_META_REQUEST:
      return state;
    case mapFilterConstant.FILTER_META_SUCCESS:
      return {
        ...state,
        filterMetaData: action.resp.data.data,
      };
    case mapFilterConstant.FILTER_META_FAILURE:
      return {
        ...state,
        filterMetaError: action.error,
      };

    //GET AREAS
    case mapFilterConstant.LOAD_AREAS_REQUEST:
      return state;
    case mapFilterConstant.LOAD_AREAS_SUCCESS:
      return {
        ...state,
        getAreasData: action.resp.data.data?.area,
      };
    case mapFilterConstant.LOAD_AREAS_FAILURE:
      return {
        ...state,
        getAreasError: action.error,
      };

    //MAP FILTER RESULTS
    case mapFilterConstant.FILTER_REQUEST:
      return {
        ...state,
        dataLoading: true,
      };
    case mapFilterConstant.FILTER_SUCCESS:
      return {
        ...state,
        showFilters: false, // Is set to false in order to show incident detail window
        dataLoading: false,
        filter: true, // Is set to true since we have triggered filter incident btn
        nextPage: action?.response?.nextPage,
        recordCount: action?.response?.recordCount,
        totalRecordCount: action?.response?.totalRecordCount,
        filterData: action?.response?.filteredRecords,
        heatMapData: action?.response?.heatMapRecords,
      };
    case mapFilterConstant.FILTER_FAILURE:
      return {
        ...state,
        dataLoading: false,
        filterDataError: action.error,
        heatMapDataError: action.error,
      };

    //MAP FILTER RESULTS
    case mapFilterConstant.NEXTPAGE_FILTER_REQUEST:
      return {
        ...state,
        dataLoading: true,
      };
    case mapFilterConstant.NEXTPAGE_FILTER_SUCCESS:
      const filterdataArray = state.filterData;
      const updatedFilterDataArray = action?.response?.filteredRecords;
      return {
        ...state,
        filter: true,
        showFilters: false,
        dataLoading: false,
        nextPage: action?.response?.nextPage,
        recordCount: action?.response?.recordCount,
        totalRecordCount: action?.response?.totalRecordCount,
        filterData: filterdataArray.concat(updatedFilterDataArray),
        heatMapData: action?.response?.heatMapRecords,
      };
    case mapFilterConstant.NEXTPAGE_FILTER_FAILURE:
      return {
        ...state,
        dataLoading: false,
        filterDataError: action.error,
        heatMapDataError: action.error,
      };

    //MAP LOAD DATA
    case mapFilterConstant.LOAD_MAP_REQUEST:
      return {
        ...state,
        showFilters: true, // sidebar filter screen handler
        sidebarOpen: false, // sidebar open close handler
        mapLoading: true,
        filter: false,
      };
    case mapFilterConstant.LOAD_MAP_SUCCESS:
      return {
        ...state,
        todayIncident: false,
        mapLoading: false,
        nextPage: action?.response?.nextPage,
        recordCount: action?.response?.recordCount,
        totalRecordCount: action?.response?.totalRecordCount,
        filterData: action?.response?.filteredRecords,
        heatMapData: action?.response?.heatMapRecords,
      };
    case mapFilterConstant.LOAD_MAP_FAILURE:
      return {
        ...state,
        mapLoading: false,
        filterDataError: action.error,
        heatMapDataError: action.error,
      };

    //MAP LOAD DATA
    case mapFilterConstant.TODAY_INCIDENT_REQUEST:
      return {
        ...state,
        showFilters: true, // sidebar filter screen handler
        sidebarOpen: false, // sidebar open close handler
        mapLoading: true,
        filter: false,
      };
    case mapFilterConstant.TODAY_INCIDENT_SUCCESS:
      return {
        ...state,
        todayIncident: true,
        mapLoading: false,
        nextPage: action?.response?.nextPage,
        recordCount: action?.response?.recordCount,
        totalRecordCount: action?.response?.totalRecordCount,
        filterData: action?.response?.filteredRecords,
        heatMapData: action?.response?.heatMapRecords,
      };
    case mapFilterConstant.TODAY_INCIDENT_FAILURE:
      return {
        ...state,
        mapLoading: false,
        filterDataError: action.error,
        heatMapDataError: action.error,
      };

    case mapFilterConstant.SET_ZOOM_LEVEL:
      return {
        ...state,
        zoomObject: action.response,
        // zoomLayer: action.response,
      };
    case mapFilterConstant.SET_FILTER:
      return {
        ...state,
        showFilters: action.response,
      };
    case mapFilterConstant.SET_SIDEBAR:
      return {
        ...state,
        sidebarOpen: action.response,
      };
    case mapFilterConstant.RESOLVE_ERROR:
      return {
        ...state,
        filterDataError: null,
        heatMapDataError: null,
        filterMetaError: null,
      };
    case mapConstants.SHOW_POLYGON_REQUEST:
      return {
        ...state,
        showMyPolygonList: action.val,
      };
    default:
      return state;
  }
};
export default mapReducer;
